import { graphql } from "react-relay";

export const feedSchedulerInputFragments = {
  viewer: graphql`
    fragment FeedSchedulerInput_viewer on Viewer
    @argumentDefinitions(
      queryInput: { type: "String!" }
      orgRelayId: { type: "ID!" }
      excludeCalendars: { type: "[String]" }
      externalGroupRefetch: { type: "Boolean!", defaultValue: false }
    ) {
      personQueryResultErrorable(
        query: $queryInput
        orgRelayId: $orgRelayId
        excludeCalendars: $excludeCalendars
      ) @skip(if: $externalGroupRefetch) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on PersonQueryResult {
          query
          persons {
            id
            primaryEmail
            emails
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
      groupQueryResult(
        query: $queryInput
        orgRelayId: $orgRelayId
        excludeCalendars: $excludeCalendars
      ) @skip(if: $externalGroupRefetch) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on ExternalGroupSearchResult {
          inputQuery
          groups {
            emailAddress
            groupSize
          }
        }
      }
      teamQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId)
        @skip(if: $externalGroupRefetch) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on TeamQueryResult {
          query
          teams {
            teamName
            teamId
            teamRoleAndPersonIds {
              role
              personId
            }
          }
          teamMembers {
            role
            person {
              personId
              isYou
              primaryCalendarId
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
        }
      }
    }
  `,
  org: graphql`
    fragment FeedSchedulerInput_org on Org
    @argumentDefinitions(
      emails: { type: "[String!]!", defaultValue: [] }
      externalGroupRefetch: { type: "Boolean!", defaultValue: false }
      teamId: { type: "String!", defaultValue: "" }
      teamAttendeesRefetch: { type: "Boolean!", defaultValue: false }
    ) {
      id
      externalGroups(emails: $emails) @include(if: $externalGroupRefetch) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on ExternalGroupList {
          list {
            email
            memberEmails
          }
        }
      }
      teamForTeamId(teamId: $teamId) @include(if: $teamAttendeesRefetch) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Team {
          teamId
          teamName
          teamMembers {
            person {
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
          invitedMembers {
            person {
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
        }
      }
    }
  `,
};

export const feedSchedulerInputQuery = graphql`
  query FeedSchedulerInputQuery(
    $queryInput: String!
    $orgRelayId: ID!
    $excludeCalendars: [String]
    $emails: [String!]!
    $externalGroupRefetch: Boolean!
    $teamId: String!
    $teamAttendeesRefetch: Boolean!
  ) {
    viewer: viewer {
      ...FeedSchedulerInput_viewer
        @arguments(
          queryInput: $queryInput
          orgRelayId: $orgRelayId
          excludeCalendars: $excludeCalendars
          externalGroupRefetch: $externalGroupRefetch
        )
    }
    org: node(id: $orgRelayId) {
      ... on Org {
        ...FeedSchedulerInput_org
          @arguments(
            emails: $emails
            externalGroupRefetch: $externalGroupRefetch
            teamId: $teamId
            teamAttendeesRefetch: $teamAttendeesRefetch
          )
      }
    }
  }
`;
